import axios from "axios";
import { MainApiUrl } from "../../../../Imports/MainApiUrl";

export const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export async function displayRazorpay(result, userDetails, navigate) {
  const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

  if (!res) {
    alert("Razorpay SDK failed to load. Are you online?");
    return;
  }

  // Getting the order details back
  const { amount, orderId: order_id, currency, key, back_url, formNo } = result;

  const options = {
    key,
    amount: amount.toString(),
    currency: currency,
    name: "",
    description: "Test Transaction",
    image: { logo: "" },
    order_id: order_id,

    handler: async function (response) {
      const data = {
        orderCreationId: order_id,
        razorpayPaymentId: response.razorpay_payment_id,
        razorpayOrderId: response.razorpay_order_id,
        razorpaySignature: response.razorpay_signature,
      };
      const result = await axios.post(
        `${MainApiUrl}student/online-fee-payment?orderCreationId=${data.orderCreationId}&razorpayPaymentId=${data.razorpayPaymentId}&razorpayOrderId=${data.razorpayOrderId}&razorpaySignature=${data.razorpaySignature}`,
        data
      );

      if (result?.status == 200 && back_url && formNo) {
        navigate(
          `/registration/applications/form/transaction?status=SUCCESS&formNo=${formNo}`
        );
      } else if (result?.status == 200) {
        if (window?.paymentChannel) {
          window.paymentChannel.postMessage(
            JSON.stringify({
              status: "SUCCESS",
              action: "Close",
            })
          );
        } else {
          navigate("/home/student/transactionhistory?status=SUCCESS");
        }
      } else {
        if (back_url && formNo) {
          navigate(
            `/registration/applications/form/transaction?status=FAILURE&formNo=${formNo}`
          );
        } else {
          if (window?.paymentChannel) {
            window.paymentChannel.postMessage(
              JSON.stringify({
                status: "FAILURE",
                action: "Close",
              })
            );
          } else {
            navigate("/home/student/transactionhistory?status=FAILURE");
          }
        }
      }
    },
    prefill: {
      name: userDetails?.name,
      email: userDetails?.email,
      contact: userDetails?.number,
    },
    notes: {
      address: userDetails?.address,
    },
    theme: {
      color: "#61dafb",
    },
  };

  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
}
